export const Borders = {
  radius: {
    tiny: 4,
    small: 8,
  },
  width: {
    thin: 1,
  },
};
